import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import './ccModal2025.scss';
import PropTypes from 'prop-types';
const CCModal2025 = ({
	onClose,
	isShow,
	title,
	btnCloseText,
	btnSubmitText,
	onSubmit,
  backdrop,
  size,
  onCloseFooter,
  className,
  dialogClassName,
	...props
}) => {
  const handleCloseFooter = () => {
    if(onCloseFooter) {
      onCloseFooter()
      return;
    }
    onClose();
  }
  return (
    <Modal
      show={isShow}
      backdrop={backdrop?? 'static'}      
      aria-labelledby="contained-modal-title-sm"
      dialogClassName={`card-dialog serviceModal ${dialogClassName}`}
      className={`confirm ccModal2025 ${className}`}
      onHide={onClose}
      size={size}
    >
      <Modal.Header closeButton>
        <div>
          <Modal.Title>{title}</Modal.Title>
          {props.titleNote ? props.titleNote : null}
        </div>
        <button
          type="button"
          className="close"
          aria-label="Close"
          onClick={onClose}
        >
          <span aria-hidden="true">×</span>
        </button>
      </Modal.Header>
      <Modal.Body className="clearfix popupFlight text">
				{
					props.children
				}
      </Modal.Body>
      {
        !props.hideFooter && (
          <Modal.Footer>
            <Button className="mr-md btn-header text-add-header" onClick={handleCloseFooter}>
              {btnCloseText || <Translate value="driver.Close" />}
            </Button>
            {
              !props.hideSubmitButton && (
                <Button className="btn-save mr-md" onClick={onSubmit} disabled={props.disabledSubmit}>
                  {btnSubmitText || <Translate value="corporate.Save" />}
                </Button>
              )
            }
          </Modal.Footer>
        )
      }
    </Modal>
  );
};

CCModal2025.propTypes = {
  title: PropTypes.string.isRequired,
  titleNote: PropTypes.any,
  onClose: PropTypes.func.isRequired,
  isShow: PropTypes.bool.isRequired,
  btnCloseText: PropTypes.string,
  btnSubmitText: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.node,
  disabledSubmit: PropTypes.bool,
  hideSubmitButton: PropTypes.bool,
  hideFooter: PropTypes.bool,
}
export default CCModal2025;